import { Disableable } from '@optimus-web/common';
import { IconName } from '@optimus-web/icons';

export type LinkVariant = 'default' | 'basic';

export enum LinkState {
    Disabled = 'disabled',
    Inherit = 'inherit',
    Inline = 'inline',
    Standalone = 'standalone',
}

export interface LinkProps extends Disableable, React.AnchorHTMLAttributes<HTMLAnchorElement> {
    as?: React.ElementType;
    children?: React.ReactNode;
    inherit?: boolean;
    overflowWrap?: 'normal' | 'break-word';
    size?: 'normal' | 'small';
    standalone?: boolean;
    underline?: boolean;
    wordBreak?: 'break-all' | 'break-word' | 'normal';
    variant?: LinkVariant;
    icon?: IconName;
    strong?: boolean;
}
